// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foot[data-v-60f35ab6] {\n  clear: both;\n  text-align: center;\n  line-height: 50px;\n  color: #ffffff;\n  bottom: 0px;\n  width: 100%;\n  font-size: 14px;\n  margin-top: 30px;\n  background: #021b5f;\n}\n", ""]);
// Exports
module.exports = exports;
